import { useLayoutEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useCompanies = () => {
    const [active, setActive] = useState("companies");
    const { getSearchParams } = useSearchParams();
    const { platformId } = useParams();
    const navigate = useNavigate(); 
    const toggle = (id) => {
        navigate(`/product/${platformId}/companies/?tab=${id}`);
        setActive(id);
    };
    useLayoutEffect(() => {
        let isActive = true;
        if (isActive) {
            if (!getSearchParams("tab")) {
                toggle("companies");
            } else {
                setActive(String(getSearchParams("tab")));
            }
        }
        return () => {
            isActive = false;
        };
    }, []);

    return {
        toggle,
        active
    };
    
};

export default useCompanies;